"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postalCodeValidationGlobal = exports.postalCodeValidationAny = exports.phoneNumberValidator = exports.emailValidator = exports.alphaNumericValidator = void 0;
const emailValidator = value => {
  // RFC 2822 compliant regex
  let regex = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/i;
  return value.match(regex) ? true : false;
};
exports.emailValidator = emailValidator;
const postalCodeRegex = new RegExp("^[A-Za-z0-9 -]{3,10}$");
const USregex = new RegExp("^\\d{5}(-{0,1}\\d{4})?$");
const CAregex = new RegExp("^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$");
const MXregex = new RegExp("^d{5}$");
const postalCodeValidationAny = value => {
  if (!value) {
    return false;
  }
  value = value.trim();
  if (USregex.test(value.toString())) {
    return true;
  }
  if (CAregex.test(value.toString().toUpperCase())) {
    return true;
  }
  if (MXregex.test(value.toString())) {
    return true;
  }
  return false;
};
exports.postalCodeValidationAny = postalCodeValidationAny;
const postalCodeValidationGlobal = value => {
  if (!value) {
    return false;
  }
  value = value.trim();
  if (postalCodeRegex.test(value.toString())) {
    return true;
  }
  return false;
};
exports.postalCodeValidationGlobal = postalCodeValidationGlobal;
const alphaNumRegex = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ0-9&,-.']+$");
const alphaNumericValidator = value => {
  if (!value) {
    return false;
  }
  value = value.trim().replace(/\s/g, "");
  if (alphaNumRegex.test(value)) {
    return true;
  }
  return false;
};
exports.alphaNumericValidator = alphaNumericValidator;
const phoneNumRegex = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
const phoneNumberValidator = value => {
  if (!value) {
    return false;
  }
  value = value.trim().replace(/\s/g, "");
  if (phoneNumRegex.test(value)) {
    return true;
  }
  return false;
};
exports.phoneNumberValidator = phoneNumberValidator;